import { Scheme } from '@@/schemes/ts';
import {
  SingleSchemeImage,
  PairSchemeImage,
  SequenceSchemeImage,
} from '@@/schemes/images';

export const SCHEMES_IMAGES_DICTIONARY = {
  [Scheme.Single]: SingleSchemeImage,
  [Scheme.Pair]: PairSchemeImage,
  [Scheme.Sequence]: SequenceSchemeImage,
};

export const SCHEMES_INFO_DICTIONARY = {
  [Scheme.Single]: {
    name: 'Последовательная',
    label: 'Последовательная загрузка и разгрузка рукавов',
    description: 'Максимальное наполнение рукавного склада',
    image: SCHEMES_IMAGES_DICTIONARY[Scheme.Single],
  },
  [Scheme.Pair]: {
    name: 'Попарная',
    label: 'Попарная загрузка и разгрузка рукавов',
    description: 'Оптимальная схема размещения рукавов',
    image: SCHEMES_IMAGES_DICTIONARY[Scheme.Pair],
  },
  [Scheme.Sequence]: {
    name: 'Групповая',
    label: 'Групповая загрузка и разгрузка рукавов',
    description: 'Максимальное количество рукавов на поле',
    image: SCHEMES_IMAGES_DICTIONARY[Scheme.Sequence],
  },
};
